// extracted by mini-css-extract-plugin
module.exports = {"titleDescriptionItem":"TitleDescriptionItem_titleDescriptionItem__LU6aL"};